'use strict';

import { lockScroll, unlockScroll } from 'Util/util';
import VZOpenDrawer from 'Components/drawers/VZOpenDrawer';

/**
 * Minicart functionality for managing active states
 * Adds/removes active class when minicart drawer opens/closes
 */
export default class Minicart {
    constructor() {
        this.minicartButton = document.querySelector('.js-minicart-trigger');
        this.init();
    }

    init() {
        if (!this.minicartButton) return;

        document.addEventListener('minicart:open', this.handleMinicartOpen.bind(this));
        document.addEventListener('minicart:close', this.handleMinicartClose.bind(this));

        this.minicartButton.addEventListener('click', Minicart.handleMinicartToggle);
        document.addEventListener('click', this.handleBackdropClick.bind(this));
    }

    /**
     * Handle when minicart opens
     * @param {Event} _event - Custom minicart:open event
     */
    handleMinicartOpen(_event) {
        this.minicartButton.classList.add('active');

        const pageHeader = document.querySelector('.js-page-header');
        if (pageHeader) {
            pageHeader.classList.add('minicart-open');
        }

        // Lock scroll when minicart opens
        lockScroll();

        // Set top position based on page header height
        Minicart.setMinicartDrawerPosition();
    }

    /**
     * Handle when minicart closes
     * @param {Event} _event - Custom minicart:close event
     */
    handleMinicartClose(_event) {
        this.minicartButton.classList.remove('active');

        const pageHeader = document.querySelector('.js-page-header');
        if (pageHeader) {
            pageHeader.classList.remove('minicart-open');
        }

        // Unlock scroll when minicart closes
        unlockScroll();
    }

    /**
     * Handle minicart button toggle functionality
     * @param {Event} event - Click event on minicart button
     */
    static handleMinicartToggle(event) {
        const minicartDrawer = document.querySelector('.js-minicart-drawer');

        // If minicart is already open, close it
        if (minicartDrawer && minicartDrawer.classList.contains('show')) {
            event.preventDefault();
            event.stopPropagation();
            Minicart.closeMinicart();
        }
    }

    /**
     * Handle backdrop clicks to close minicart
     * @param {Event} event - Click event
     */
    handleBackdropClick(event) {
        const minicartDrawer = document.querySelector('.js-minicart-drawer');

        // Only handle if minicart is open
        if (!minicartDrawer || !minicartDrawer.classList.contains('show')) {
            return;
        }

        // Check if click is outside the minicart drawer
        if (!minicartDrawer.contains(event.target) && !this.minicartButton.contains(event.target)) {
            Minicart.closeMinicart();
        }
    }

    /**
     * Close the minicart drawer
     */
    static closeMinicart() {
        const minicartDrawer = document.querySelector('.js-minicart-drawer');
        if (minicartDrawer) {
            VZOpenDrawer.closeDrawer(minicartDrawer);
        }
    }

    /**
     * Set the top position of the minicart drawer based on page header height
     */
    static setMinicartDrawerPosition() {
        const pageHeader = document.querySelector('.js-page-header');
        const minicartDrawer = document.querySelector('.js-minicart-drawer');

        if (pageHeader && minicartDrawer) {
            const headerHeight = pageHeader.offsetHeight;
            minicartDrawer.style.top = `${headerHeight}px`;
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const minicart = new Minicart();
    return minicart;
});
